export const readStatusOptions = [
  { label: 'Read', value: true },
  { label: 'Unread', value: false },
];

export const signatureStatusOptions = [
  { label: 'All Types', value: '' },
  { label: 'Signed', value: 'SIGNED' },
  { label: 'Pending Signature', value: 'PENDING' },
];

export const chipItems = [
  { label: 'All Files', value: 'all' },
  { label: 'Client Uploads', value: 'uploads' },
  { label: 'Unread', value: 'unread' },
  { label: 'Signed Documents', value: 'signed' },
];

export const uploadedByOptions = [
  { label: 'All Uploads', value: 'all' },
  { label: 'Client Uploads', value: 'client' },
  { label: 'Firm Uploads', value: 'firm' },
];

export const retryOptions = [
  { label: '1 Attempt', value: 1 },
  { label: '2 Attempts', value: 2 },
  { label: '3 Attempts', value: 3 },
];

export const fileSizeOptions = [
  { label: 'Small (< 1MB)', value: 'small' },
  { label: 'Medium (1-10MB)', value: 'medium' },
  { label: 'Large (10-100MB)', value: 'large' },
  { label: 'Very Large (> 100MB)', value: 'very_large' },
];

export const advancedFilterReadStatusOptions = [
  { label: 'Read', value: 'read' },
  { label: 'Unread', value: 'unread' },
];

export const advancedFilterSignatureStatusOptions = [
  { label: 'Signed', value: 'signed' },
  { label: 'Pending', value: 'pending' },
  { label: 'Not Required', value: 'not_required' },
];

export const FILE_MANAGER_ACCEPT =
  '.jpg, .jpeg, .png, .heic, .heif, .pdf, .doc, .docx, .xls, .xlsx, .txt, .mov, .wav, .mp3, .rtf, .mpeg, .mp4, .aac, .3gp, .avi, .wmv, .wma, .csv, .ppt, .pptx';

export const ALLOWED_EXTENSIONS = [
  'jpg',
  'jpeg',
  'png',
  'heic',
  'heif',
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'txt',
  'mov',
  'wav',
  'mp3',
  'rtf',
  'mpeg',
  'mp4',
  'aac',
  '3gp',
  'avi',
  'wmv',
  'wma',
  'csv',
  'ppt',
  'pptx',
];
